<div class="flex-row tight">
    <label>
        By entering my mobile number, I agree to receive text messages from Parenting with Purpose. Message frequency varies.
        Message and data rates may apply. Text STOP to cancel. View privacy policy <a target="_blank" href="https://equippedparents.org/assets/privacy.htm">here</a>.
    </label>
</div>
